import React from 'react'
import styled from 'styled-components'

interface CasePropertyChangedContentProps {
  oldStatus?: string
  newStatus?: string
  field: string
}

const ContentContainer = styled.div`
  font-size: 0.875rem;
`

const MainText = styled.div`
  font-weight: 500;
  color: ${({ theme }) => theme.forecast.defaultText};
  margin-bottom: 0.25rem;
`

const ChangeText = styled.div`
  font-size: 0.75rem;
  color: ${({ theme }) => theme.forecast.tertiaryText};
  display: flex;
  align-items: center;
  gap: 0.5rem;
`

const StatusBadge = styled.span<{ $isOld?: boolean }>`
  padding: 0.125rem 0.5rem;
  border-radius: 0.25rem;
  font-size: 0.6875rem;
  font-weight: 500;
  background-color: ${({ theme, $isOld }) =>
    $isOld ? theme.forecast.navSidebarBackground : theme.forecast.primary};
  color: ${({ theme, $isOld }) =>
    $isOld ? theme.forecast.tertiaryText : theme.forecast.defaultText};
  text-decoration: ${({ $isOld }) => ($isOld ? 'line-through' : 'none')};
`

const Arrow = styled.span`
  color: ${({ theme }) => theme.forecast.tertiaryText};
  font-size: 0.75rem;
`

export const CasePropertyChangedContent: React.FC<
  CasePropertyChangedContentProps
> = ({ oldStatus, newStatus, field }) => {
  const formatFieldName = (field: string) => {
    if (field.startsWith('case_metadata.')) {
      return field.replace('case_metadata.', '').replace('_', ' ')
    }
    return field.replace('case_', '').replace('_', ' ').toLowerCase()
  }

  return (
    <ContentContainer>
      <MainText>Changed {formatFieldName(field)}</MainText>
      <ChangeText>
        {oldStatus && <StatusBadge $isOld>{oldStatus}</StatusBadge>}
        {oldStatus && newStatus && <Arrow>→</Arrow>}
        {newStatus && <StatusBadge>{newStatus}</StatusBadge>}
      </ChangeText>
    </ContentContainer>
  )
}
